import { InfiniteList } from '@prismamedia/one-components';
import classNames from 'classnames';
import { FC, useCallback } from 'react';
import { ListViewProps } from '../types';
import { ListItemCard } from './ListItemCard';
import { THUMBNAIL_LIST_HEIGHT, useStyles } from './styles';

export const ListView: FC<ListViewProps> = ({
  allowSearch,
  className,
  fetchMore,
  fetchMoreMode,
  isLoading,
  itemToRender,
  items,
  onItemClick,
  pluginType,
  selectedItems,
  ...restListViewProps
}) => {
  const classes = useStyles({ allowSearch });

  const rowRenderer = useCallback(
    (rowItem) => {
      const itemPluginType = rowItem.pluginType || pluginType;
      const item = itemToRender(rowItem, itemPluginType);
      const isSelected = selectedItems.some(
        (selectedItem) => selectedItem.id === item.id,
      );

      return (
        <div key={item.id}>
          <ListItemCard
            {...item}
            {...restListViewProps}
            isSelected={isSelected}
            onItemClick={() => {
              onItemClick(rowItem, itemPluginType);
            }}
            isSuggestionItem={rowItem.isSuggested}
          />
        </div>
      );
    },
    [itemToRender, onItemClick, pluginType, restListViewProps, selectedItems],
  );

  return (
    <InfiniteList
      className={classNames(className, classes.wrapperList)}
      fetchMore={fetchMore}
      list={items}
      loading={isLoading}
      mode={fetchMoreMode}
      rowHeight={THUMBNAIL_LIST_HEIGHT}
      rowRenderer={rowRenderer}
      threshold={5}
    />
  );
};
